import React, { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import { useTranslation } from "react-i18next";
import GeneralCancellationPolicy from "../../../components/cancellation-policy/general/cancellation-policy";

const CancellationPolicyBannerImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/cancellation-policy/cancellation-policy-banner.png";
const CancellationPolicy = () => {
  const page_name = "cms-cancellation-policy";
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();
  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(86.14deg,#181818_0.73%,rgba(40,42,45,0.3)_33.69%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
          <img
            src={CancellationPolicyBannerImage}
            alt="Cancellation Policy Banner"
            className="tw:w-full tw:h-[430px] tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t("Pricing")}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t("Cancellation.Policy")}
            </div>
          </div>
        </div>
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:my-12 tw:lg:pt-6 tw:lg:pb-12 tw:px-0">
          <GeneralCancellationPolicy />
        </div>
      </div>
    </FrontLayout>
  );
};

export default CancellationPolicy;
